<template>
  <TemplateModal
    ref="modal"
    edit
    :text="text"
    :send-function="onSave"
    :open-function="onOpen"
    minimalize
    width="700"
  >
    <div class="d-grid grid-col-sm-2-1 gap-5 gap-sm-8">
      <div class="d-grid gap-5">
        <BaseInput
          :label="t['dialog-edit-labels']['elektronnaya-pochta']"
          v-model="email"
          :rules="['required', 'email']"
        />
        <BaseInput
          :label="t['dialog-edit-labels']['imya']"
          v-model="first_name"
          :rules="['required']"
        />
        <BaseInput
          :label="t['dialog-edit-labels']['familiya']"
          v-model="last_name"
          :rules="['required']"
        />
        <BaseInput
          type="tel"
          :label="t['dialog-edit-labels']['telefon']"
          v-model="phone[0]"
          :rules="['required']"
        />
        <BlockUnblock v-if="commonUserData" />
      </div>
      <div class="d-grid gap-5 align-content-start">
        <div v-if="!subscriber">
          <label class="f14 fw500 bold primary--text">{{
            t['dialog-edit-labels']['sotrudnik']
          }}</label>
          <EmployeeCreateDelete v-if="commonUserData" class="pa-0 mt-1" />
        </div>
        <div>
          <div class="f14 fw500 bold primary--text">{{ t['dialog-edit-labels']['roli'] }}</div>
          <template v-if="commonUserData">
            <template v-if="commonUserData.roles.length > 0">
              <template v-if="$userCheckAccess({ abilities: 'remove_user_roles' })">
                <v-checkbox
                  class="mt-1"
                  v-for="(i, index) in rolesList"
                  :key="index"
                  v-model="rolesSelect"
                  :label="rolesList[index]"
                  :value="rolesList[index]"
                  hide-details
                ></v-checkbox>
              </template>
              <template v-else>
                <div v-for="(i, index) in rolesList" :key="index">{{ rolesList[index] }}</div>
              </template>
            </template>
            <v-btn v-else tile disabled outlined class="text-none mt-1">
              {{ localStorage.translations.pages.common.text['not_assigned'] }}
            </v-btn>
          </template>
        </div>
      </div>
    </div>
  </TemplateModal>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BlockUnblock from 'components/setting/users/BlockUnblock'
import EmployeeCreateDelete from 'components/setting/users/EmployeeCreateDelete'
export default {
  name: 'UserTableEdit',
  components: { EmployeeCreateDelete, BlockUnblock },
  props: {
    id: [String, Number],
    onDownloadPageData: Function,
    subscriber: Boolean,
  },
  data: () => ({
    status: null,
    email: '',
    first_name: '',
    last_name: '',
    phone: '',
    rolesList: [],
    rolesSelect: [],
    phoneInput: {
      valid: false,
      country: undefined,
    },
  }),
  computed: {
    ...mapGetters('commonUser', [
      'commonUserData',
      'commonUserDataStatus',
      'commonUserDataEmployee',
    ]),
    t() {
      return this.localStorage.translations.pages['setting-users']
    },
    text() {
      return {
        title: {
          edit: this.subscriber
            ? this.localStorage.translations.pages['sales_project'][
                'planned_resources-subscribers'
              ]['edit_subscriber']
            : this.t['dialog-edit']['redaktirovanie-polzovatelya'],
        },
      }
    },
  },
  watch: {
    rolesList() {
      if (this.rolesList) {
        this.rolesSelect = this.rolesList
      }
    },
  },
  methods: {
    ...mapActions('commonUser', [
      'onCommonUserUpdate',
      'onCommonUserGrid',
      'onCommonUserData',
      'onCommonUserBlock',
      'onCommonUserUnblock',
    ]),
    ...mapActions('employee', ['employeeCreate', 'employeeDelete']),
    ...mapActions('commonRole', ['removeRoleFromUser']),
    ...mapMutations('commonUser', ['setCommonUserData']),
    async onOpen() {
      await this.onCommonUserData(this.id).then(() => {
        this.email = this.commonUserData.email
        this.first_name = this.commonUserData.first_name
        this.last_name = this.commonUserData.last_name
        if (Array.isArray(this.commonUserData.phone)) this.phone = this.commonUserData.phone
        else this.phone = [this.commonUserData.phone]
        if (this.commonUserData.roles.length) this.onRolesName()
      })
    },
    async onSave() {
      let data
      if (
        this.commonUserData.status !== this.commonUserDataStatus &&
        this.commonUserDataStatus === 'blocked'
      ) {
        await this.onCommonUserBlock(this.commonUserData.id)
      }
      if (
        this.commonUserData.status !== this.commonUserDataStatus &&
        this.commonUserDataStatus === 'authorized'
      ) {
        await this.onCommonUserUnblock(this.commonUserData.id)
      }
      if (this.commonUserData.employee === null && this.commonUserDataEmployee === true) {
        this.employeeCreate({ user_id: this.commonUserData.id })
      }
      if (this.commonUserData.employee !== null && this.commonUserDataEmployee === false) {
        this.employeeDelete(this.commonUserData.employee.id)
      }
      await this.checkAndDeleteRoles()
      data = {
        id: this.commonUserData.id,
        email: this.email,
        first_name: this.first_name,
        last_name: this.last_name,
        phone: this.phone,
        language_id: 1,
      }
      await this.onCommonUserUpdate(data)
        .then((response) => {
          this.onDownloadPageData()
          if (response) {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications[
                    'izmeneniya-uspeshno-sohraneny'
                  ],
                IsError: false,
              },
              { root: true },
            )
            this.onDownloadPageData()
            this.setCommonUserData(null)
          }
        })
        .catch((err) => {})
    },
    onRolesName() {
      let rolesName = []
      for (let i = 0; i < this.commonUserData.roles.length; i++) {
        rolesName.push(this.commonUserData.roles[i].role_name)
      }
      this.rolesList = [...new Set(rolesName)]
    },
    checkAndDeleteRoles() {
      let intersection = this.rolesList.filter((x) => !this.rolesSelect.includes(x))
      for (let i = 0; i < intersection.length; i++) {
        this.removeRoleFromUser({
          user_id: this.commonUserData.id,
          roles: [intersection[i]],
        })
      }
    },
    changeStatus(data) {
      return (this.status = data)
    },
  },
}
</script>
